var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"text-left",attrs:{"fluid":""}},[_c('b-table',{attrs:{"hover":"","items":_vm.table}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }